/** Support / customer care contact — single source of truth so we can
 *  change the number, WhatsApp link, and hours from one file. */
export const SUPPORT_PHONE_E164 = "+919175004668";     // for tel: links
export const SUPPORT_PHONE_DISPLAY = "+91 91750 04668"; // for humans
export const SUPPORT_WHATSAPP_NUMBER = "919175004668"; // wa.me strips the +
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;
export const SUPPORT_EMAIL = "hello@jeweltix.com";
export const SUPPORT_HOURS = "Mon–Sat, 10am–7pm IST";
